import React, { useState } from "react";
import { TitleText } from "../../ui/Text";
import styled from "styled-components";
import { TaskCardItem } from "./TaskCardItem";
import { get } from "../../utils/get";
import { v4 as uuidv4 } from "uuid";
import { AddInitiative } from "./AddInitiative";
import moment from "moment";
import DetailsView from "./DetailsView";
import Modal from "../../ui/Modal";
import { useLocation } from "react-router-dom";
interface IProps {
  taskCardData: Period;
}
export const TaskCard = ({ taskCardData }: IProps) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [editData, setEditData] = useState<any>([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const location = useLocation();
  const idToReload = get(location, "key");
  return (
    <>
      {isModalOpen && (
        <Modal
          title="Add Task"
          noFooter
          noHeader
          closeModal={() => setisModalOpen(false)}
        >
          <AddInitiative
            onClick={() => setisModalOpen(false)}
            isEdit
            isOpen={isModalOpen}
            // reloadData={() => reload(idToReload)}
            editData={editData}
          />
        </Modal>
      )}
      {isPaneOpen && (
        <DetailsView
          onClick={() => setIsPaneOpen(false)}
          isOpen={isPaneOpen}
          // isEdit

          setisModalOpen={setisModalOpen}
          data={editData}
        />
      )}
      <>
        <TaskContainer
          key={uuidv4()}
          onClick={() => {
            setEditData([taskCardData]);
            setIsPaneOpen(true);
          }}
        >
          <TitleText>
            {moment(get(taskCardData, "due_date", "")).format(
              "MMM DD, HH:mm a"
            )}
          </TitleText>
          <TaskVerticalLine>
            <VerticalLine />
            <TaskIndicatorContainer>
              <TaskIndicator />
            </TaskIndicatorContainer>
            <VerticalLine />
          </TaskVerticalLine>
          <TaskCardItem
            backgroundColor="#F5F6FB"
            taskCardItemData={taskCardData}
          />
        </TaskContainer>
      </>
    </>
  );
};
const TaskContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5em 1em auto;
  grid-column-gap: 1em;
  ${TitleText} {
    align-self: center;
    font-size: 0.7em;
  }
`;
const TaskVerticalLine = styled.div`
  display: grid;
  grid-template-rows: auto 0.7em auto;
  align-items: center;
`;
const TaskIndicatorContainer = styled.div`
  height: 0.6em;
  width: 0.65em;
  display: flex;
  justify-content: center;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-items: center;
  border: 1px solid #ebeeff;
  border-radius: 0.6em;
`;

const TaskIndicator = styled.div`
  height: 0.3em;
  width: 0.3em;
  background-color: #01A8CE;
  border-radius: 0.15em;
`;

const VerticalLine = styled.div`
  height: 100%;
  border-right: 1px solid #ebeeff;
  justify-self: center;
`;
